<template>
  <div class="content">
    <h2 style="font-size: 0.2rem;">联考之家用户协议</h2>
    <p>欢迎您使用博雅爱文MBA联考之家（以下简称联考之家、我们或本网站）。本网站由北京博雅爱文教育科技有限公司所有和运营。您应当仔细阅读、充分理解《用户协议》和《隐私政策》（简称本协议）的全部内容。</p>
    <h3 style="font-size: 0.16rem;">一、协议的确认</h3>
    <p>您访问联考之家、注册成为联考之家用户或使用联考之家的任何产品或服务，即视为您已阅读、了解并完全同意本协议中的各项内容，包括本网站对条款内容所作的任何修改。同时也代表您同意我们的《隐私政策》，其内容涵盖了我们如何收集、使用、披露、存储和保护您的个人信息。</p>
    <p>若您不同意本协议，请不要注册、访问或以其他方式使用联考之家提供的任何产品或服务。</p>
    <h3 style="font-size: 0.16rem;">二、协议的修改</h3>
    <p>本协议的内容可能会不时修改，以适应法律、技术或业务的发展。修改后的协议将在联考之家公布，重大变更将以网站公告、用户通知等合适的形式向您告知。</p>
    <p>在我们发布或发送关于条款更改的通知后，若反对任何更改，您可注销账号（联系客服人工注销）或停止使用我们提供的产品或服务。若您继续使用我们的任何产品或服务，即表示您同意修改后的条款。</p>
    <p>修改内容的适用不具有追溯力。</p>
    <h3 style="font-size: 0.16rem;">三、账号的管理和使用</h3>
    <p>1．如果您是未满16岁的未成年人，须在监护人的陪同和帮助下仔细阅读本协议，并在征得您监护人同意的前提下，使用我们的产品或服务或向我们提供信息。</p>
    <p>2．您可以使用电子邮箱或手机号进行注册，获得联考之家账号和密码，登录联考之家。您在联考之家的账号、密码等是您在本网站的唯一身份权证。您通过账号和密码使用本网站的行为，均视为您本人行为，您应当承担由此导致的相关后果和责任。</p>
    <p>3．您应当妥善保管您的账号、密码和手机短信验证码，避免使用过于简单的密码。不得将您的账号和密码出租、出借、转让或者以其他方式提供给他人使用。您可以根据本网站规定更改密码、更新个人注册信息。如果您发现自己的信息泄露，尤其是本网站账号和密码发生泄露，请立即联系我们。</p>
    <p>4．您在使用具体产品或服务时，我们可能会要求您进一步提供本人身份信息及资料，以完成身份信息核验，您应保证提供的身份信息及资料为本人真实、准确的信息。</p>
    <h3 style="font-size: 0.16rem;">四、用户的权利与义务</h3>
    <p>1．在遵守有关法律法规及本协议约定的前提下，您有权按照产品或服务的要求，使用我们提供的产品或服务。</p>
    <p>2．我们提供的部分产品或服务需要获得您授权终端设备的部分信息方可正常使用，我们按照相关法律法规，以最小化权限原则进行授权获取的提示。您有权不同意，但可能会影响您正常使用我们的产品或服务。</p>
    <p>3．您使用联考之家应当符合国家法律法规的规定，且行为符合下列要求：</p>
    <p>（1）不干扰本网站的正常运转，不进行任何破坏或试图破坏网络安全的行为，不进行任何改变或试图改变本网站系统配置或破坏系统安全的行为，不得侵入或试图侵入本网站信息系统和管理后台；</p>
    <p>（2）不对本网站展示或提供的、由联考之家所有的任何数据或信息作商业性利用，包括但不限于在未经联考之家事先书面同意的情况下，以复制、传播等任何方式使用本网站展示或提供的、由联考之家所有的资料、信息、数据等；</p>
    <p>（3）不模仿、修改、翻译、改编、出借、出售、转许可、传播或转让本网站提供的服务，也不得逆向工程、反汇编、反编译、分解拆卸或试图以其他方式发现本网站提供的服务的源代码；</p>
    <p>（4）不发送、上传和储存带有病毒、蠕虫、木马和其他有害内容的计算机代码、文件、脚本和程序；</p>
    <p>（5）遵守所有与网络服务有关的的协议、规定、程序和惯例；</p>
    <p>（6）不从事其他违反法律法规规定或本协议约定的行为。</p>
    <p>4．您不得通过本网站制作、复制、发布、传播含有下列内容的信息：</p>
    <p>（1）反对宪法所确定的基本原则的；</p>
    <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>（3）损害国家荣誉和利益的；</p>
    <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>（9）含有法律、行政法规禁止的其他内容的。</p>
    <p>5．若您存在违反法律规定或本协议约定的任一情形，联考之家有权按相关规定暂停或终止提供服务，保存有关记录，并向政府主管部门报告，由此引起的一切后果和责任由您负责。同时，联考之家有权终止本协议，并不承担任何责任。</p>
    <p>6．您违反本协议使用联考之家产品或服务导致联考之家或第三方损失的，应当承担相应法律责任、赔偿联考之家或第三方的损失。</p>
    <h3 style="font-size: 0.16rem;">五、我们的权利和义务</h3>
    <p>1．我们有义务在现有技术上维护联考之家的正常运行，并努力提升和改进技术方案，提供更好的产品或服务，使您顺利的使用联考之家的产品或服务。我们也有义务在《隐私政策》框架内，保护联考之家的收集的您的个人信息。</p>
    <p>2．对您在注册或使用我们提供的产品或服务过程中，遇到的有关问题或反映的情况，我们应及时作出回复。</p>
    <p>3．由于部分产品或服务的需要，我们可能通过产品或服务中的通知或您提供的邮箱、手机号码、微信等联系方式给您发送通知和服务信息，其方式和范围可不经向您特别通知而变更。</p>
    <p>4．如果您购买我们的任何付费服务，则表示您同意向我们支付相应费用并同意相关付费服务的使用规则，我们有权更改或修改产品或服务价格。在法律允许的范围内，这些更改可能在向您发送通知时开始生效。</p>
    <p>5．我们有权修改、暂停或终止任何免费产品或服务。</p>
    <p>6．我们有权对您提供的资料信息进行核验，核验结果适用于您在本网站办理注册以及查询验证等相关服务,如您提供的资料不准确，或无法通过核验，或本网站有合理的理由认为该资料信息不真实、不完整、不准确，本网站有权暂停或终止您的注册身份及资料，并拒绝您使用本网站的服务。</p>
    <p>7．我们有权删除利用他人身份信息非法注册的联考之家账号，并保留追究其相关法律责任的权利。</p>
    <p>8．对于您在联考之家上的不当行为或其他任何联考之家认为应当终止服务的情况，我们有权随时作出删除相关信息、终止服务提供等处理，而无须征得您的同意。</p>
    <p>9．联考之家的图形、图像、文字及其程序等均属联考之家之版权，受商标法及相关知识产权法律保护；未经书面许可，任何人不得下载或复制，严禁对上述对象进行再使用。在联考之家发布信息之商标，归其相应的商标所有权人，受商标法保护。</p>
    <h3 style="font-size: 0.16rem;">六、协议的终止</h3>
    <p>联考之家或您均可在任何时间通知对方终止本协议。一旦协议终止，您就失去了访问或使用联考之家产品或服务的权利。但以下内容将不会终止:</p>
    <p>（1）联考之家使用和公开您所反馈的意见的权利；</p>
    <p>（2）其他用户或访客分享您在协议终止之前被复制或分享的内容和信息的权利；</p>
    <p>（3）任何一方在协议终止前所欠的费用在协议终止后仍然成立；</p>
    <p>（4）其他根据本协议内容应继续有效的条款，以及本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。</p>
    <h3 style="font-size: 0.16rem;">七、免责声明</h3>
    <p>1．联考之家不能保证网站不受黑客、病毒的侵害，不能完全保证网站无故障运行。因正常的系统维护、系统升级，或者因网络拥塞而导致网站不能访问，本网站不承担任何责任；</p>
    <p>2．用户对在联考之家中发布信息的准确性和合法性独立承担一切法律责任；</p>
    <p>3．对于他方输入的、联考之家上链接的其他网站等不是联考之家发布的内容，联考之家不承担任何法律责任；</p>
    <p>4．对于因用户本人身份等信息泄露而导致本网站信息被他人获取所造成的任何损失，联考之家不承担任何法律责任；</p>
    <p>5．因非联考之家原因导致用户的账号、密码遗失、遗忘或被他人窃取的，联考之家不承担责任。</p>
    <h3 style="font-size: 0.16rem;">八、适用法律和纠纷解决</h3>
    <p>本用户协议遵守中华人民共和国法律，如发生与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款仍保持对用户产生法律效力和影响。您与联考之家就本协议或其他有关事项发生的争议，应首先友好协商解决，协商不成时，应将纠纷或争议提请联考之家备案归属地有管辖权的法院管辖。</p>
  </div>
</template>

<script>

export default {
  name: 'Protocol',
  data() {
    return {}
  },
  created() {},
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}
.content-data {
  display: inline-block;
  text-align: center;
  width: 10rem;
  padding-bottom: 0.03rem;
}
p {
  font-size: 0.13rem;
  font-family: tahoma, arial, 'Microsoft YaHei', "Hiragino Sans GB", SimSun, sans-serif;
  text-indent: 0.26rem;
  margin-bottom: 0.08rem;
  margin-top: 0.08rem;
  line-height: 0.22rem;
  text-align:justify;
}
</style>
